
/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const DEFAULT_CONTENT_CROP = 120
